export const TestIds = {
  container: 'chat-empty-state',
  avatar: 'chat-empty-state-avatar',
  title: 'chat-empty-state-title',
};
